module.exports = __webpack_public_path__ + "media/images/pen_midnightblue-1691c8b9.png";